import { render, staticRenderFns } from "./CardToolbar.vue?vue&type=template&id=504a9c56&"
import script from "./CardToolbar.vue?vue&type=script&lang=js&"
export * from "./CardToolbar.vue?vue&type=script&lang=js&"
import style0 from "./CardToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports